export function dispatchSystemVisibilityChange({ system, visibility, }) {
    window.dispatchEvent(new CustomEvent("PM-VisibilityChange", {
        detail: { system, visibility },
    }));
}
